import { Toast } from 'antd-mobile'
import _ from 'lodash'
import currencyFormatter from 'currency-formatter'
import * as enums from './enum'
import moment from 'moment'
import UAParser from 'ua-parser-js'
import intl from './intl'
import messages from 'languages/messages'
import queryString from 'query-string'
moment.locale(getCurrentLanguage())

export function checkFormError(errors) {
  // check passed form errors, if this is no error, return true, else show the first error
  if (!errors) {
    return true
  }
  const msg = _.chain(errors)
    .values()
    .map('errors')
    .flatten()
    .first()
    .get('message')
    .value()
  Toast.info(msg)
  return false
}

export function getUUID(length = 32) {
  return [...Array(length)].map((i) => (~~(Math.random() * 36)).toString(36)).join('')
}

export function handleDate(date, formatter = 'DD-MM-YYYY HH:mm:ss') {
  return date ? moment(date).format(formatter) : ''
}

export function handleAmount(data, symbol, precision = 2) {
  if (data) {
    const currency = symbol || data.currency
    return currencyFormatter.format(data.amount, {
      symbol: currency,
      precision: precision,
      format: currency ? '%s %v' : '%v' // %s is the symbol and %v is the value
    })
  }
  return '0.00'
}

export function decimalToPercent(point) {
  if (point) {
    var string = Number(point * 100).toFixed(2)
    string += '%'
    return string
  }
  return '0.00%'
}

export function getCurrentLanguage(params) {
  // 从User-Agent获取语言，兼容IOS无法设置webview语言
  const data = PayByInfo()
  const supportLanguages = ['en', 'ar']
  const currentLanguage = data.lang || window.navigator.language.split(/[-_]/)[0]
  return supportLanguages.indexOf(currentLanguage) > -1 ? currentLanguage : 'en'
}

export function setHtmlLangAndDir(language) {
  document.documentElement.setAttribute('lang', language)
  if (language === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl')
  } else {
    document.documentElement.removeAttribute('dir')
  }
}

export function isPayBy() {
  // 判断是否在PayBy环境下
  return navigator.userAgent.toLowerCase().indexOf('payby') !== -1
}

export function PayByInfo() {
  // PayBy/${PayBySDKVersion} (${hostAppName}, ${hostAppVersion}, ${IP}, ${mobileBrand})
  // 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_4_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 PayBy/1.5.1 (payby, 1.3.0, 192.168.1.4, iPhone 6)'
  // 13 (payby, 2.9.0, 10.246.22.45, iPhone14,2, ar)
  const userAgent = navigator.userAgent
  if (userAgent.toLowerCase().indexOf('payby') === -1) {
    return {}
  }
  try {
    const PayBySDKVersion = userAgent.match(/PayBy\/([0-9.]+)/)[1]
    const infos = userAgent.match(/PayBy\/[0-9. ]+\(([^\\)]+)/)[1].split(', ')
    return {
      PayBySDKVersion,
      hostAppName: infos[0].trim(' '),
      hostAppVersion: infos[1].trim(' '),
      IP: infos[2].trim(' '),
      mobileBrand: infos[3].trim(' '),
      lang: infos[4] && infos[4].trim(' ')
    }
  } catch (error) {
    return {}
  }
}

export function closeWebView() {
  // 关闭webView
  console.log('closeWebView')
  if (typeof ToPayJSBridge === 'undefined') {
    return false
  }
  window.ToPayJSBridge.invoke('leaveWeb')
}

export function openUri(uri) {
  console.log('openUri:', uri)
  const OSName = new UAParser().getOS().name
  switch (OSName) {
    case 'iOS':
    case 'Android':
      window.location.href = uri
      break
    default:
      Toast.info(intl.formatMessage(messages['app.error.netWork']))
      break
  }
}

export function downloadApp(platform) {
  const OSName = new UAParser().getOS().name
  console.log(OSName)
  switch (OSName) {
    case 'Android':
      openUri(enums.downloadAppUris.Android[platform])
      break
    case 'iOS':
    case 'Mac OS':
      openUri(enums.downloadAppUris.iOS[platform])
      break
    default:
      Toast.info(intl.formatMessage(messages['app.error.downloadNotSupport']))
      break
  }
}

export function getBotimClientId() { // 获取BOTIM clientId
  return window.location.hostname === 'activities.payby.com' ? 'botJnTqkNEr8tHtxH' : 'bote0HTOSpzhWnBZ0'
}

export function openBotimOAuth(scope, callback) {
  // H5请求botim OAuth
  console.log(scope)
  function onBridgeReady() {
    try {
      // window.ToPayJSBridge.init 方法二次调用的时候会报错
      window.ToPayJSBridge.init(function(message, responseCallback) {})
    } catch (error) {
      Toast.hide()
      console.log(error)
    }
    window.ToPayJSBridge.invoke(
      'openBotimOAuth',
      {
        scope: scope,
        client_id: getBotimClientId(),
        redirect_uri: 'botmpx://me.botim.open.authorizer/index.html',
        state: ''
      },
      function(data) {
        const res = JSON.parse(data)
        console.log(res)
        if (res.errorCode === '0') {
          typeof callback === 'function' && callback(res.data.authCode)
        } else {
          Toast.info('Get auth code failed.')
        }
      }
    )
  }

  console.log(typeof ToPayJSBridge)
  if (typeof ToPayJSBridge === 'undefined') {
    document.addEventListener('ToPayJSBridgeReady', onBridgeReady, false) // ToPayJSBridgeReady
  } else {
    onBridgeReady()
  }
}

export function transformDomain(search) {
  return `https://${enums.domainList[window.location.hostname]}${search}`
}

export function redirectToOtherProject(url, project = 'mcashier') {
  const currentProject = 'activities'
  const currentHostName = window.location.hostname
  const ENUMS = {
    mtopay : ['sim-m.test2pay.com', 'uat-m.test2pay.com', 'm.payby.com'],
    mcashier : ['sim-mpaypage.test2pay.com', 'uat-mpaypage.test2pay.com', 'mpaypage.payby.com'],
    cashier : ['sim-paypage.test2pay.com', 'uat-paypage.test2pay.com', 'paypage.payby.com'],
    activities : ['sim-activities.test2pay.com', 'uat-activities.test2pay.com', 'activities.payby.com'],
  }
  const index = currentHostName === 'localhost' ? 0 : _.findIndex(ENUMS[currentProject], item => item === currentHostName)
  window.location.href = `https://${ENUMS[project][index]}${url}`
}

export function hasEmptyValue(fieldsValue, notRequiredValues = []) {
  // 判断是否存在为空的必填项，notRequiredValues非必填项
  return Object.keys(fieldsValue).some(
    (field) => !_.includes(notRequiredValues, field) && !fieldsValue[field]
  )
}

export function deeplink(url, brand = 'PayBy') {
  const deeplinks = {
    PayBy: 'https://app.payby.com/launch?feature-code=',
    ToTok: 'http://totok.ai/payby?feature-code=',
    BOTIM: 'https://botim.me/botim/payby?feature-code='
  }
  window.location.href = deeplinks[brand] + encodeURIComponent(url)
}

export function recordCountlyEvent(params) {
  // Countly埋点事件 http://wiki.test2pay.com/pages/viewpage.action?pageId=37302821
  const { query } = queryString.parseUrl(window.location.href)
  const campaignInfo = _.omitBy(query, (value, key) => !_.includes(key, 'utm'))
  const { hostAppVersion, PayBySDKVersion, hostAppName, mobileBrand = '' } = PayByInfo()
  const [brand, model] = mobileBrand.split('.')
  const { name, version } = new UAParser().getOS()
  console.log(params)
  /* eslint-disable camelcase */
  const { event_name = 'display', element_name = 'pageview' } = params
  window.Countly.q.push([
    'add_event',
    {
      key: event_name,
      count: 1,
      sum: 1.5,
      dur: 30,
      segmentation: {
        event_name,
        element_name,
        ...params,
        event_time: new Date().getTime(),
        user_id: localStorage.user_id,
        // 活动信息
        ...campaignInfo,
        // APP信息
        app_name: hostAppName,
        app_version: hostAppVersion,
        sdk_version: PayBySDKVersion,
        // 设备信息
        device_brand_name: brand,
        device_model_name: model,
        // 系统信息
        os_platform: name,
        os_version: version
      }
    }
  ])
}

export { enums as ENUMS }
export { default as intl } from './intl'
export { recordEvent, openKYC, openNative, share } from './JSBridge'
